<script lang="ts">
  import type { ShapeLinkGroup } from '$lib/sanity/schemas';
  import ShapeLink from '$components/SanityComponents/Common/ShapeLink.svelte';
  import { ComponentType } from '$lib/sanity/types';

  import { type ContentSourceMap, type StudioPathLike } from '@sanity/svelte-loader';

  export let document: ShapeLinkGroup;
  export let sourceMap: ContentSourceMap | undefined = undefined;
  export let path: StudioPathLike = [];
</script>

{#if document.links}
  {#each document.links as shapeLink, i}
    {#if shapeLink.link}
      <ShapeLink
        {sourceMap}
        path={[...path, 'links', i]}
        document={{
          _id: String(i),
          _type: ComponentType.ShapeLink,
          link: shapeLink.link,
          shape: shapeLink.shape
        }}
      />
    {/if}
  {/each}
{/if}
